import React from "react";
import PropTypes from "prop-types";

/**
 * Renders htmls for the given format, used in File Type dropdown in download dialog
 *
 * @param {object} format
 * @param {string} format.tag
 * @param {string} format.name
 * @param {string} format.description
 * @returns {JSX.Element}
 * @constructor
 *
 * @author Ahsan Ejaz <ahsan@250mils.com>
 */
const FormatItem = ({format}) => {
    return (
        <div className={'format-item'}>
            <div className={'format-info'}>
                <span className={"item-name content-body body-s"}>{format.name}</span>
                {format.tag && <span className={"item-tag -success body-xxs-bold"}>{format.tag}</span>}
            </div>
            <p className={'item-desc body-xs content-disabled'}>{format.description}</p>
        </div>
    )
}

FormatItem.propTypes = {
    /**
     * Object containing format details (name, description etc)
     */
    format: PropTypes.object.isRequired
}

export default FormatItem